import { useContext } from 'react';

import { StyleContext } from 'App';

const useAppStyles = () => useContext(StyleContext);

export default useAppStyles;
